import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, Typography, Box, Container, Button,FormGroup, Grid, Radio, RadioGroup, FormLabel, FormControl, IconButton, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton.js';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedDetailChangeByKey } from "./common/useValidatedDetailChangeByKey.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp11_2Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [previewFiles, setPreviewFiles] = useState([]);
  const createFlameDetail = () => ({
    fire_items: "",
    flame_retardant_id: "",
  });

  console.log(changeModalOpen)

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
  
  const [formData, setFormData] = useState({
    user_11_2_name: "",
    user_11_2_department: "",
    user_11_2_phone: "",
    user_11_2_tel: "",
    alfa_text: '',
    flame_details: [createFlameDetail()],
  });

  const [corrections, setCorrections] = useState({
    user_11_info: false,
    flame_details: false,
  });

  const field_name_map = {
    user_11_info: "担当者情報",
    flame_details: "防炎対象物品",
  };

  const [memoText, setMemoText] = useState('');

  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections(prev => ({
      ...prev,
      [fieldKey]: e.target.checked
    }));
  };

  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };

  const handleCorrection = async () => {
    try {
      const selectedFields = Object.entries(corrections)
        .filter(([_, checked]) => checked)
        .map(([field]) => field_name_map[field] || field);

      if (selectedFields.length === 0) {
        alert('修正対象の項目を選択してください');
        return;
      }

      const currentPath = window.location.pathname;

      await api.patch('/api/host-correction', {
        exhibitor_id: exhibitorId,
        form_type: 'o11_2',
        correction: selectedFields,
        memo: memoText,
        current_path: currentPath,
      });

      // 👇 これ追加
      updateStatus(exhibitorId, 'o11_2', {
        host: '未確認',
        corporate: '未確認',
      });

      alert('修正リクエスト送信完了');
      setFormModalOpen(false);

      setCorrections(
        Object.fromEntries(Object.keys(corrections).map(k => [k, false]))
      );
      setMemoText('');

    } catch (err) {
      console.error(err);
      alert('修正処理でエラーが発生しました');
    }
  };

  const updateHostStatus = (exhibitorId, formType, newStatus) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              [`${formType}_host_status`]: newStatus,
              [`${formType}_corporate_status`]: newStatus, // ←これ追加
            }
          : ex
      )
    );
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });
      
      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [formErrors, setFormErrors] = useState({}); // フィールドごとのエラーを保持

  // 半角整数チェック関数
  const isInteger = (val) => /^[0-9]+$/.test(val);

  const handleArrayChange = (key, index, field, value) => {
    const updated = [...formData[key]];
    let errorMsg = "";

    // 数値フィールドのときだけ整数チェック
    if (["alchol_quantity", "oil_quantity", "gas_quantity", "fire_amount"].includes(field)) {
      if (value === "" || isInteger(value)) {
        // OK → 数値化（空文字は空のまま）
        updated[index][field] = value === "" ? "" : Number(value);
      } else {
        // NG → 値はそのまま保持してエラーメッセージ
        updated[index][field] = value;
        errorMsg = "半角数字（整数）のみ入力してください";
      }
    } else {
      // 文字列系フィールドはそのまま
      updated[index][field] = value;
    }

    setFormData({ ...formData, [key]: updated });

    // エラーを更新
    setFormErrors((prev) => {
      const newErrors = { ...prev };
      if (errorMsg) {
        newErrors[`${key}_${index}_${field}`] = errorMsg;
      } else {
        delete newErrors[`${key}_${index}_${field}`];
      }
      return newErrors;
    });
  };

  const handleAdd = (key, initial = {}) => {
    setFormData({ ...formData, [key]: [...formData[key], initial] });
  };

  const handleDelete = (key, index) => {
    const updated = [...formData[key]];
    updated.splice(index, 1);
    setFormData({ ...formData, [key]: updated });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_11_2_name: mypageData.user_name || "",
        user_11_2_department: mypageData.department || "",
        user_11_2_phone: mypageData.phone_number || "",
        user_11_2_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_11_2_name: "",
        user_11_2_department: "",
        user_11_2_phone: "",
        user_11_2_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  useEffect(() => {
    const fetchO11InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO11, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o11_2submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o11Status = resStatus.data?.o11_2_status || "";
        const o11Data = resO11.data || {};
        const mypage = resMypage.data || {};

        if (o11Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_11_2_name: null,
            user_11_2_department: null,
            user_11_2_phone: null,
            user_11_2_tel: null,
            alfa_text: null,
            flame_details: [createFlameDetail()],          
            });
        } else {
            if (Object.values(o11Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o11Data,
                flame_details: o11Data.flame_details?.length ? o11Data.flame_details : [createFlameDetail()],
            }));
            if (
              o11Data.user_11_2_name === mypage.user_name &&
              o11Data.user_11_2_department === mypage.department &&
              o11Data.user_11_2_phone === mypage.phone_number &&
              o11Data.user_11_2_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O11初期データ取得エラー:", err);
        }
    };

    fetchO11InitialData();
    }, []);

  // useEffect(() => {
  //   const fetchPreviewUrls = async () => {
  //     const previews = await Promise.all(
  //       formData.sds_pathes.map(async (file) => {
  //         if (!file?.safety_path) return file;

  //         const parts = file.safety_path.split("/").filter(Boolean);
  //         const exhibitorId = parts[1];
  //         const filename = parts[parts.length - 1];

  //         if (!exhibitorId || isNaN(Number(exhibitorId))) {
  //           console.warn("不正な safety_path:", file.safety_path);
  //           return { ...file, previewUrl: null };
  //         }

  //         try {
  //           const res = await api.get(
  //             `/api/files/o11/${exhibitorId}/${filename}?t=${Date.now()}`,
  //             { responseType: "blob" }
  //           );

  //           const url = URL.createObjectURL(res.data);
  //           return {
  //             ...file,
  //             previewUrl: url,
  //             mimeType: res.data.type,
  //             name: filename,
  //           };
  //         } catch (err) {
  //           console.error("ファイル取得失敗:", err);
  //           return { ...file, previewUrl: null };
  //         }
  //       })
  //     );

  //     setPreviewFiles(previews);
  //   };

  //   if (!formData.sds_pathes?.length) {
  //     setPreviewFiles([]);
  //     return;
  //   }

  //   fetchPreviewUrls();
  // }, [formData.sds_pathes]);


  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_11_2_name: "",
            user_11_2_department: "",
            user_11_2_phone: "",
            user_11_2_tel: "",
            alfa_text: null,
            flame_details: [createFlameDetail()],
          });
      }
  };
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const sanitizeFormData = (data) => {
        if (Array.isArray(data)) {
          return data.map(sanitizeFormData);
        } else if (typeof data === "object" && data !== null) {
          const newObj = {};
          for (const [key, value] of Object.entries(data)) {
            if (value === "") {
              newObj[key] = null;
            }
            // --- 数値フィールド ---
            else if (
              [
                "category",
              ].includes(key)
            ) {
              newObj[key] =
                value !== null && value !== "" && !isNaN(Number(value))
                  ? Number(value)
                  : null;
            }
            // --- 文字列フィールド ---
            else if (
              [
                "fire_items",
                "flame_retardant_id",
                "extinguisher",
                "alfa_text",
                "user_11_2_name",
                "user_11_2_department",
                "user_11_2_phone",
                "user_11_2_tel",
                "safety_path",
              ].includes(key)
            ) {
              newObj[key] = value != null ? String(value) : null;
            }
            // --- 再帰 ---
            else {
              newObj[key] = sanitizeFormData(value);
            }
          }
          return newObj;
        }
        return data;
      };

      const normalizedFlameDetails = (formData.flame_details || []).filter(
        (item) => item?.fire_items?.trim() || item?.flame_retardant_id?.trim()
      );
      const sanitizedFormData = sanitizeFormData({
        ...formData,
        flame_details: normalizedFlameDetails,
      });

      const submitErrors = {};

      if (!notApply) {
        // 基本必須項目チェック
        if (!formData.user_11_2_name?.trim())
          submitErrors.user_11_2_name = "入力してください";
        if (!formData.user_11_2_phone?.trim())
          submitErrors.user_11_2_phone = "入力してください";
        if (!formData.user_11_2_tel?.trim())
          submitErrors.user_11_2_tel = "入力してください";

        if (!normalizedFlameDetails.length) {
            submitErrors.flame_details_0 =
              "防炎対象物　画面横の＋追加から入力欄を表示し、入力してください";
        } else {
          formData.flame_details.forEach((item, idx) => {
            const hasAnyValue = item?.fire_items?.trim() || item?.flame_retardant_id?.trim();
            if (!hasAnyValue) {
              return;
            }
            if (!item.fire_items?.trim()) {
              submitErrors[`flame_details_${idx}_fire_items`] = "物品名を入力してください";
            }
            if (!item.flame_retardant_id?.trim()) {
              submitErrors[`flame_details_${idx}_flame_retardant_id`] = "登録番号を入力してください";
            }
          });
        }
      }

      const fieldDisplayNames = {
        user_11_2_name: "担当者名",
        user_11_2_department: "担当部署",
        user_11_2_phone: "担当者携帯",
        user_11_2_tel: "担当者電話",
        flame_details_0:
          "防炎対象物　画面横の＋追加から入力欄を表示し、入力してください",
        extinguisher: "消火器設備",
      };

      if (Object.keys(submitErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: sanitizedFormData,
        notApply: notApply,
      };

      const res = await api.post("/api/submit-o11_2", payload);

      if (res.status === 200) {
        setNoticeModalOpen(true);
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };


  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };
  const user = JSON.parse(localStorage.getItem("user"));
  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://ex-link.net'; // 本番 HTTPS
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 防炎対象物品申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00111BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00111bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Typography variant="h6" gutterBottom>
              修正内容のメモ
            </Typography>
            <TextField
              multiline
              rows={20}
              fullWidth
              placeholder="ここに修正内容を書いてください..."
              value={memoText}
              onChange={(e) => setMemoText(e.target.value)}
            />
            <Box>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">防炎対象物品申込</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.user_11_info}
                        onChange={handleCorrectionChange( 'user_11_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="担当者情報"
                  />
                )}
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_11_2_name" value={formData.user_11_2_name} disabled={fieldsDisabled} onChange={handleChange("user_11_2_name")} error={!!submitErrors.user_11_2_name} helperText={submitErrors.user_11_2_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_11_2_department" value={formData.user_11_2_department} disabled={fieldsDisabled} onChange={handleChange("user_11_2_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_11_2_phone" value={formData.user_11_2_phone} disabled={fieldsDisabled} onChange={handleChange("user_11_2_phone")} error={!!submitErrors.user_11_2_phone} helperText={submitErrors.user_11_2_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_11_2_tel" value={formData.user_11_2_tel} disabled={fieldsDisabled} onChange={handleChange("user_11_2_tel")} error={!!submitErrors.user_11_2_tel} helperText={submitErrors.user_11_2_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
             
                <Box>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.flame_details}
                        onChange={handleCorrectionChange( 'flame_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="防炎対象物"
                  />
                )}
                <Typography variant="h6" gutterBottom>防炎対象物品</Typography>

                {formData.flame_details.map((item, index) => (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <TextField
                      label="物品名"
                      value={item.fire_items}
                      onChange={(e) =>
                        handleArrayChange("flame_details", index, "fire_items", e.target.value)
                      }
                      error={!!submitErrors[`flame_details_${index}_fire_items`]}
                      helperText={submitErrors[`flame_details_${index}_fire_items`]}
                    />
                    <TextField
                      label="登録番号"
                      value={item.flame_retardant_id}
                      onChange={(e) =>
                        handleArrayChange("flame_details", index, "flame_retardant_id", e.target.value)
                      }
                      error={!!submitErrors[`flame_details_${index}_flame_retardant_id`]}
                      helperText={submitErrors[`flame_details_${index}_flame_retardant_id`]}
                    />
                    {formData.flame_details.length >= 1 && (
                      <IconButton
                        onClick={() => handleDelete("flame_details", index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                    </Box>
                ))}
                <Button onClick={() => handleAdd("flame_details", { fire_items: "", flame_retardant_id: "" })} startIcon={<Add />}>追加</Button>
                {/* <Typography variant="subtitle2" gutterBottom>消火器設備</Typography>
                <TextField fullWidth label="消火器(○○型○○本)" value={formData.extinguisher} onChange={(e) => setFormData({ ...formData, extinguisher: e.target.value })} error={!!submitErrors.extinguisher} helperText={submitErrors.extinguisher} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.sdss}
                        onChange={handleCorrectionChange( 'user_4_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="SDS・カタログ等"
                  />
                )}
                <Typography variant="h6" gutterBottom>SDS・カタログアップロード</Typography>
                <input
                    type="file"
                    id="sds-upload"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    onChange={handleFileChange}
                    disabled={uploading}
                />

                <div style={{ marginTop: "1rem" }}>
                  <Typography variant="subtitle2">画像はクリックで拡大できます。</Typography>
                  {previewFiles.length === 0 ? (
                    <p>まずアップロードして下さい。</p>
                  ) : (
                    previewFiles.map((file, idx) => (
                      <div
                        key={idx}
                        style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.5rem" }}
                      >
                        {file.previewUrl && file.mimeType?.startsWith("image/") ? (
                          <img
                            key={idx}
                            src={file.previewUrl}
                            alt="preview"
                            onClick={(e) => {
                              e.target.classList.toggle("zoomed");
                            }}
                            style={{
                              width: 100,
                              height: "auto",
                              cursor: "zoom-in",
                              transition: "transform 0.3s ease",
                            }}
                            className="zoom-image"
                          />
                        ) : file.previewUrl && file.mimeType === "application/pdf" ? (
                          <a
                            href={`${baseUrl}/api/get-pdf/${exhibitorId}/${file.name}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            PDFを別タブで開いて確認
                          </a>
                        ) : (
                          <a href={file.previewUrl} target="_blank" rel="noopener noreferrer">
                            {file.safety_path.split("/").pop()}
                          </a>
                        )}
                        {!isCorpModal &&(
                        <IconButton onClick={() => handleDeleteFile(idx)}><Delete /></IconButton>
                        )}
                      </div>
                    ))
                  )}
                </div> */}
                </Box>
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※防炎対象物品について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            </>
            )}
        </FormGroup>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            ビジネスフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
        <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
          <DialogTitle>注意事項</DialogTitle>
          <DialogContent>
            <p>
              防炎対象物品・危険物品の設置位置を「ブース平面図」よりご提出ください。
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotice} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp11_2Sub;
